/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created` at Tue Oct 29 2024
 **/

import { _T, _P } from "@rfice/language";
import { Properties } from "@/frameworks/libraries/properties";

import { useXRMNavigate } from "../useXRMNavigate";
import useConfirm from "./useConfirm";
import SignupImg from "@/assets/images/popup/img_invite_visual_01.png";

export default function useGuestSignupConfirm() {
	const { confirm } = useConfirm();
	const { navigate } = useXRMNavigate();
	const isGuest = Properties.property.isGuest;

	const showSignupConfirm = () => {
		confirm(
			{
				title: _P("해당 메뉴는 Rfice 가입 후 이용이 가능합니다.<br />Rfice를 가입하시겠습니까?"),
				descriptionImg: SignupImg,
				confirmText: _T("가입하기")
			},
			{
				onConfirm() {
					navigate("/join");
				}
			}
		);
	};

	const handleAction = (action: () => void) => {
		if (isGuest) {
			showSignupConfirm();
		} else {
			action();
		}
	};

	return handleAction;
}
